module.exports = __webpack_public_path__ + "img/gb-seething.8e5a044d.webp";